// ====== CONFIG: change these four numbers to control timing (in ms) ======
const MAGMA_OVERLAY_FADE_IN_MS  = 350;
const MAGMA_OVERLAY_FADE_OUT_MS = 200;
const MAGMA_POPUP_FADE_IN_MS    = 250;
const MAGMA_POPUP_FADE_OUT_MS   = 200;

const magmaOverlay = document.getElementById("magma-overlay");
const magmaPopup   = document.getElementById("magma-popup");

// Helper: set transition durations separately for in/out
function setFadeDurations(isOpening) {
    if (isOpening) {
        magmaOverlay.style.transition = `opacity ${MAGMA_OVERLAY_FADE_IN_MS}ms ease`;
        magmaPopup.style.transition =
            `transform ${MAGMA_POPUP_FADE_IN_MS}ms ease, ` +
            `opacity ${MAGMA_POPUP_FADE_IN_MS}ms ease`;
    } else {
        magmaOverlay.style.transition = `opacity ${MAGMA_OVERLAY_FADE_OUT_MS}ms ease`;
        magmaPopup.style.transition =
            `transform ${MAGMA_POPUP_FADE_OUT_MS}ms ease, ` +
            `opacity ${MAGMA_POPUP_FADE_OUT_MS}ms ease`;
    }
}

function magmaOpenPopup() {
    setFadeDurations(true);                // use fade-IN durations
    magmaOverlay.style.display = "flex";

    // Next frame → add classes so transitions apply
    requestAnimationFrame(() => {
        magmaOverlay.classList.add("magma-overlay--visible");
        magmaPopup.classList.add("magma-popup--open");
    });
}

function magmaClosePopup() {
    setFadeDurations(false);               // use fade-OUT durations

    magmaPopup.classList.remove("magma-popup--open");
    magmaOverlay.classList.remove("magma-overlay--visible");

    // Wait for the overlay opacity transition to finish, then hide
    const handleTransitionEnd = (e) => {
        if (e.propertyName === "opacity") {
            magmaOverlay.style.display = "none";
            magmaOverlay.removeEventListener("transitionend", handleTransitionEnd);
        }
    };
    magmaOverlay.addEventListener("transitionend", handleTransitionEnd);
}

// Click outside popup to close
magmaOverlay.addEventListener("click", function(e) {
    if (e.target === magmaOverlay) magmaClosePopup();
});


  window.magmaOpenShippingProtectionPopup = function () {
    window.magmaOpenPopup();
  };

  MAGMA_INFO.register({
    scope: '#insureful-container .insureful-widget3 .pti-desc',
    icon: 'ⓘ',
    onClick: 'magmaOpenShippingProtectionPopup',
    ariaLabel: 'Shipping Protection information'
  });